import React, { useState, useEffect } from 'react';

import S from './SelectInput.module.scss';

const SelectInput = ({ argument, onChange }) => {
  const [value, setValue] = useState('');

  // Initialiser la valeur depuis l'argument
  useEffect(() => {
    const initialValue = argument.valeurParDefaut || argument.value || '';
    setValue(initialValue);
  }, [argument.valeurParDefaut, argument.value]);

  // Mettre à jour la valeur
  const handleChange = (selectedValue) => {
    setValue(selectedValue);
    onChange('valeurParDefaut', selectedValue);
  };

  // Récupérer les options depuis argument.options (format API)
  const options = argument.options || [];

  return (
    <div className={S.selectContainer}>
      <select
        value={value}
        onChange={(e) => handleChange(e.target.value)}
        className={S.selectInput}
        required={argument.obligatoire}
      >
        <option value="">-- Sélectionner --</option>
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.key}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectInput;
